// assets
import { IconLayoutDashboard, IconBriefcase, IconReportAnalytics, IconUsersGroup, IconHistory } from '@tabler/icons-react';

// constant
const icons = { IconLayoutDashboard, IconBriefcase, IconReportAnalytics, IconUsersGroup, IconHistory };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const architectDashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    roles: ['super_admin', 'system_admin', 'department_head'],
    permissions: ['dashboard.read'],
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/architecture/dashboard',
            icon: icons.IconLayoutDashboard,
            breadcrumbs: false
        },
        {
            id: 'projects',
            title: 'All Projects',
            type: 'item',
            url: '/architecture/projects',
            icon: icons.IconBriefcase,
            // 🔒 Visible to anyone who can read projects
            permissions: ['projects.read']
        },
        {
            id: 'performance',
            title: 'Officers',
            type: 'item',
            url: '/architecture/team',
            target: false,
            icon: icons.IconUsersGroup,
            roles: ['department_head', 'system_admin', 'super_admin'],
            permissions: ['dashboard.read']
        },
        // {
        //     id: 'reports',
        //     title: 'Reports',
        //     type: 'item',
        //     icon: icons.IconReportAnalytics,
        //     url: '/architecture/reports',
        //     target: false,
        //     permissions: ['reports.read']
        // },
        {
            id: 'audit',
            title: 'Audit Logs',
            type: 'item',
            icon: icons.IconHistory,
            url: '/architecture/audit-logs',
            target: false,
            permissions: ['audit_logs.read']
        }
    ]
};

export default architectDashboard;
